import { useEffect } from "react";
import { useLocation } from "react-router";
import { canFocusable, getFocusableChilds } from "../utils/query-focusables";

function useScrollIntoView() {
  const location = useLocation();

  useEffect(() => {
    let intervalExecCount = 0;
    const anchor = (location.hash) ? location.hash.replace("#", "") : 'content-top';

    const intervalId = setInterval(() => {
      const targetEl = document.getElementById(anchor);
      intervalExecCount++;

      if (targetEl) {
        targetEl.scrollIntoView({ behavior: "smooth", block: "start" });

        if (canFocusable(targetEl)) {
          targetEl.focus({ preventScroll: true });
        }
        else {
          const focusables = getFocusableChilds(targetEl);
          focusables[0]?.focus({ preventScroll: true });
        }

        clearInterval(intervalId);
      } else if (intervalExecCount > 50) {
        clearInterval(intervalId);
      }
    }, 100);
  }, [location]);
}

export default useScrollIntoView;
